export default __webpack_public_path__ + "static/media/HardDiskMuseum.da97a7b1.png";